import Icon from '../components/Icon.vue'

Icon.register({
  'user-tie': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM319.8 288.6c71.3 3.4 128.2 61.7 128.2 133.8v41.6c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-41.6c0-72.1 56.9-130.4 128.2-133.8l47.8 191.4 32-136-32-56h96l-32 56 32 136z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-tie.js
// module id = 2077
// module chunks = 0